import { data } from 'services';

export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      { name: 'name', title: t('form.ФИО') },
      { name: 'is_active', title: t('dict_filter.Статус'), width: 145, render: (val) => data.getDictValue('users.status', val) },
      { name: 'card_id', title: t('sections.БСК'), width: 165 },
    ];

    return fields;
  };

  return { getFields };
};
